__webpack_public_path__ =  appConfig.reactStaticFilePath ||'//scache-ws.vzw.com/e/imageFiles/intl/omni/';
